import { Timestamp } from "firebase/firestore";
import { IBoirFilingResponse, IEntitySubmitConsent } from "./entity.interface";
import { UUID } from "./general.interface";

export interface INewsletterPost {
  title: string;
  description: string;
  postUrl: string;
  postImageUrl: string;
}

export interface IStripeLineItems {
  [key: string]: {
    line_items: { price: string; quantity: number; coupon?: string }[];
    discounts?: { coupon: string }[];
    mode: "payment" | "setup" | "subscription";
  };
}

export interface IBoirQueueItem extends IBoirFilingResponse {
  entityId: UUID;
  consentData: IEntitySubmitConsent;
  submittedSuccessfully: boolean;
  createdAt: Timestamp;
  orgId: UUID | null;
}

export interface IWebFilingResponse {
  status: string | null;
  submissionTrackingId: UUID | null;
  receivedTimestampUtc: string | null;
  reportingCompanyFincenId: string | null;
  boirId: UUID | null;
}

export interface IWebBoirFilingQueueItem {
  orgId: UUID | null;
  entityId: UUID;
  submittedSuccessfully: boolean;
  response?: IWebFilingResponse;
}

export const cloudFunctionNames = {
  user: {
    sendUserInvite: "user-sendUserInvite",
    validateUserInvite: "user-validateUserInvite",
    replaceTempId: "user-replaceTempId",
    markEmailVerified: "user-markEmailVerified",
    checkIfEmailInUse: "user-checkIfEmailInUse",
  },
  entity: {
    verifyDob: "entity-verifyDob",
    moveEntityGroup: "entity-moveEntityGroup",
    getTotalEntityProgress: "entity-getTotalEntityProgress",
    validateEntityBulkUpload: "entity-validateEntityBulkUpload",
    uploadBulkEntitiesCollection: "entity-uploadBulkEntitiesCollection",
    mirrorEntityFromUser: "entity-mirrorEntityFromUser",
    mirrorEntityProgressFromUser: "entity-mirrorEntityProgressFromUser",
    mirrorEntityToGroup: "entity-mirrorEntityToGroup",
    mirrorDeleteEntityFromUser: "entity-mirrorDeleteEntityFromUser",
  },
  imageCollection: {
    sendMultipleAutoCollectEmails: "imageCollection-sendMultipleAutoCollectEmails",
    decodeImageCollectionToken: "imageCollection-decodeImageCollectionToken",
    sendSingleAutoCollectEmail: "imageCollection-sendSingleAutoCollectEmail",
    autoCollectUploadOwner: "imageCollection-autoCollectUploadOwner",
  },
  secureFileTransfer: {
    sendInvitationEmail: "secureFileTransfer-sendInvitationEmail",
    validateSecureFileInvitationToken: "secureFileTransfer-validateSecureFileInvitationToken",
    linkUserToEntity: "secureFileTransfer-linkUserToEntity",
    revokeSecureFileInvite: "secureFileTransfer-revokeSecureFileInvite",
    canBeHandedOffInstantly: "secureFileTransfer-canBeHandedOffInstantly",
    sendInstantlyTransferEmail: "secureFileTransfer-sendInstantlyTransferEmail",
    updateEntityDetailsWithTransfer: "secureFileTransfer-updateEntityDetailsWithTransfer",
    updateEntityDetailsWithInstantTransfer: "secureFileTransfer-updateEntityDetailsWithInstantTransfer",
  },
  stripe: {
    createSetupCheckoutSession: "stripe-createSetupCheckoutSession",
    listPaymentMethods: "stripe-listPaymentMethods",
    addPaymentMethod: "stripe-addPaymentMethod",
    createCheckoutSession: "stripe-createCheckoutSession",
    checkStripeSessionStatus: "stripe-checkStripeSessionStatus",
    createSubscription: "stripe-createSubscription",
    listInvoices: "stripe-listInvoices",
    listAllInvoices: "stripe-listAllInvoices",
    getSubscriptionOrSessionStatus: "stripe-getSubscriptionOrSessionStatus",
    createCharge: "stripe-createCharge",
    cancelSubscription: "stripe-cancelSubscription",
  },
  boirProxy: {
    obtainAccessTokenCallable: "boirProxy-obtainAccessTokenCallable",
    initiateBOIR: "boirProxy-initiateBOIR",
    checkSubmissionStatus: "boirProxy-checkSubmissionStatus",
    getTranscript: "boirProxy-getTranscript",
    processBoirSubmission: "boirProxy-processBoirSubmission",
  },
  reviewReport: {
    createHtmlReport: "reviewReport-createHtmlReport",
    createDeprecatedHtmlReport: "reviewReport-createDeprecatedHtmlReport",
    createSnapshotHtmlReport: "reviewReport-createSnapshotHtmlReport",
  },
  boirAttachment: {
    getTranscriptFromStorage: "boirAttachment-getTranscriptFromStorage",
  },
  alerts: {
    sendEmailAlert: "alerts-sendEmailAlert",
  },
  owner: {
    getAllOwners: "owner-getAllOwners",
    getOwner: "owner-getOwner",
    searchOwners: "owner-searchOwners",
    getOwnersByEntityId: "owner-getOwnersByEntityId",
    removeEntityFromOwner: "owner-removeEntityFromOwner",
    removeOrgEntitiesFromOwner: "owner-removeOrgEntitiesFromOwner",
    uploadGovIdImage: "owner-uploadGovIdImage",
    getPersonOwnersPaginated: "owner-getPersonOwnersPaginated",
    getEntityOwnersPaginated: "owner-getEntityOwnersPaginated",
  }
}
